// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__81LPc","rootParamsCollapsed":"styles_rootParamsCollapsed__3VbsA","rootPreviewFull":"styles_rootPreviewFull__1lngl","loader":"styles_loader__1bl3e"};